import { Zodiac } from '../api';

// Canonical editorial slugs from landing/content/ascendant-*.topic.json.
const slugs: Record<Zodiac, Record<'pt' | 'en' | 'es' | 'fr', string>> = {
  Aries: { pt: 'ascendente-em-carneiro', en: 'aries-rising', es: 'ascendente-en-aries', fr: 'ascendant-belier' },
  Taurus: { pt: 'ascendente-em-touro', en: 'taurus-rising', es: 'ascendente-en-tauro', fr: 'ascendant-taureau' },
  Gemini: { pt: 'ascendente-em-gemeos', en: 'gemini-rising', es: 'ascendente-en-geminis', fr: 'ascendant-gemeaux' },
  Cancer: { pt: 'ascendente-em-caranguejo', en: 'cancer-rising', es: 'ascendente-en-cancer', fr: 'ascendant-cancer' },
  Leo: { pt: 'ascendente-em-leao', en: 'leo-rising', es: 'ascendente-en-leo', fr: 'ascendant-lion' },
  Virgo: { pt: 'ascendente-em-virgem', en: 'virgo-rising', es: 'ascendente-en-virgo', fr: 'ascendant-vierge' },
  Libra: { pt: 'ascendente-em-balanca', en: 'libra-rising', es: 'ascendente-en-libra', fr: 'ascendant-balance' },
  Scorpio: { pt: 'ascendente-em-escorpiao', en: 'scorpio-rising', es: 'ascendente-en-escorpio', fr: 'ascendant-scorpion' },
  Sagittarius: { pt: 'ascendente-em-sagitario', en: 'sagittarius-rising', es: 'ascendente-en-sagitario', fr: 'ascendant-sagittaire' },
  Capricorn: { pt: 'ascendente-em-capricornio', en: 'capricorn-rising', es: 'ascendente-en-capricornio', fr: 'ascendant-capricorne' },
  Aquarius: { pt: 'ascendente-em-aquario', en: 'aquarius-rising', es: 'ascendente-en-acuario', fr: 'ascendant-verseau' },
  Pisces: { pt: 'ascendente-em-peixes', en: 'pisces-rising', es: 'ascendente-en-piscis', fr: 'ascendant-poissons' },
};

export function ascendantGuideUrl(sign: Zodiac | undefined, language: string): string | undefined {
  if (!sign || !slugs[sign]) return undefined;
  const baseLanguage = language.toLowerCase().split('-')[0];
  const locale = baseLanguage === 'en' || baseLanguage === 'es' || baseLanguage === 'fr' ? baseLanguage : 'pt';
  const section = locale === 'en' ? 'astrology' : locale === 'fr' ? 'astrologie' : 'astrologia';
  return `https://senti.pt/${locale}/${section}/${slugs[sign][locale]}/` +
    '?utm_source=senti&utm_medium=free-tool&utm_campaign=gr006-mapa-gratis&utm_content=ascendant-guide';
}
